import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SegmentedProgressBar } from "./SegmentedProgressBar";
import { Text } from "./Text";
import { View } from "./View";
import { useI18n } from "../lib/i18n";
import { useTheme } from "../styles";
/**
 * Progress bar for learn sessions.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-96}
 */ export function LearnProgress(param) {
    var numCompleted = param.numCompleted, numTotal = param.numTotal, backgroundColor = param.backgroundColor;
    var theme = useTheme().theme;
    var $t = useI18n().$t;
    return /*#__PURE__*/ _jsxs(View, {
        testID: "LearnProgress",
        style: {
            backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.color.accentTwo100,
            padding: 10,
            marginHorizontal: -20
        },
        row: true,
        "aria-label": $t({
            id: 'LearnProgress_accessibilityLabel',
            defaultMessage: 'Learn progress. {numCompleted} of {numTotal} completed'
        }, {
            numCompleted: numCompleted,
            numTotal: numTotal
        }),
        children: [
            /*#__PURE__*/ _jsx(Text, {
                text: $t({
                    id: 'LearnProgress_progressText',
                    defaultMessage: '{numCompleted}/{numTotal}'
                }, {
                    numTotal: numTotal,
                    numCompleted: numCompleted
                }),
                testID: "LearnProgress_progressText",
                color: "white",
                style: {
                    marginHorizontal: 12
                }
            }),
            /*#__PURE__*/ _jsx(SegmentedProgressBar, {
                length: numTotal,
                progress: numCompleted,
                variant: "dark",
                height: 10,
                gap: 1
            })
        ]
    });
}
